import { mutator } from 'satcheljs';
import { updateInitialParameters } from '../actions/internalActions';
import { getParameterStore } from '../store/ParametersStore';

mutator(updateInitialParameters, actionMessage => {
    const parameterStore = getParameterStore();
    parameterStore.mailboxInfo = actionMessage.mailboxInfo;
    parameterStore.scenarioName = actionMessage.scenarioName;
});
